import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class UtilService {

  constructor() { }

  public generateColorCode() : string {
    // Generate random values for red, green, and blue components
    const red = Math.floor(Math.random() * 256); // 0 to 255
    const green = Math.floor(Math.random() * 256); // 0 to 255
    const blue = Math.floor(Math.random() * 256); // 0 to 255

    // Convert RGB values to hexadecimal format
    const redHex = red.toString(16).padStart(2, '0'); // Convert to hex and ensure 2 digits
    const greenHex = green.toString(16).padStart(2, '0'); // Convert to hex and ensure 2 digits
    const blueHex = blue.toString(16).padStart(2, '0'); // Convert to hex and ensure 2 digits

    // Concatenate the components to form the color code
    const colorCode = `#${redHex}${greenHex}${blueHex}`;

    return colorCode;
  }
}
